




















import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter, Mutation, State } from 'vuex-class';
import { mapGetters } from 'vuex';
import { Photo } from '../../models/photo';

import AnalysisQuestions from '../analysis/AnalysisQuestions.vue';
import AnalysisPhotos from '../analysis/AnalysisPhotos.vue';
import EmailTheResults from '../analysis/followup/EmailTheResults.vue';
import Introduction from '../introduction/Introduction.vue';
import { Option } from '@/models/option';
import { Topic } from '@/models/topic';

@Component({
    components: {
        AnalysisQuestions,
        AnalysisPhotos,
        Introduction,
        EmailTheResults,
    },

    computed: {
        currentTab: {
            get() {
                return this.$store.state.wizard.currentTab;
            },

            set(value) {
                this.$store.commit('wizard/setCurrentTab', value);
            },
        },
    },
})
export default class Wizard extends Vue {
    @Getter('topic/topics') private topics: Topic[];
    @Getter('configuration/selectedOptions') private selectedOptions: Option[];
    @Getter('configuration/photosLiked') private photosLiked: Photo[];
    @Getter('configuration/photosDisliked') private photosDisliked: Photo[];

    get userNotLikedAndDisliked() {
        return this.photosDisliked.length === 0 && this.photosLiked.length === 0;
    }
}
